export default __webpack_public_path__ + "static/media/wash-plus-llc.7e747417.webp";